import { PropsWithChildren } from 'react';
import styles from './Disclaimer.module.scss';
import classNames from 'classnames';
import { WithClassName } from '../types';
export const Disclaimer = ({ children, className }: PropsWithChildren<WithClassName>) => (
  <div className={classNames(styles.disclaimer, className)}>{children}</div>
);
